//GLOBAl LIBRARIES
import "./libs/splide/splide_custom_initialize.js";
